<template>
  <v-container>
    <v-card class="mx-auto pa-3" max-width="800" min-height="400">
      <!--
      <v-card-title>Hamochi Bright Future Family Plan</v-card-title>
      <v-card-subtitle
        >Thank you for showing interest to upgrade your account to Hamochi
        Bright Future Family Plan!
        <span v-if="appliedCoupon">Coupon Applied: {{ appliedCoupon.key }}</span>
      </v-card-subtitle>
      -->
      <v-stepper elevation="0" v-model="step">
        <v-stepper-header>
          <v-stepper-step step="1" :complete="step > 1">{{ $t("view.SlideUpgradeForm.step_payment") }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="step > 2">{{ $t("view.SlideUpgradeForm.step_done") }}</v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <AError
        v-if="api.isError"
        :api="api"
        :callbackReset="() => (api.isError = false)"
      ></AError>
      <AError
        v-if="submitApi.isError"
        :api="submitApi"
        :callbackReset="() => (submitApi.isError = false)"
      ></AError>
      <v-card-text>
        <v-form ref="formName" v-model="valid" lazy-validation>
          <div v-if="step == 1">
            <!--
            <div class="black--text">Choose your plan</div>
            <div class="text-center">
              <v-radio-group v-model="selectedPlan" mandatory>
                <v-radio
                  v-for="(plan, index) in planPrices.PlanPricing"
                  :key="index"
                  :label="
                    plan.label ||
                    `RM ${(
                      ((100 - plan.discount) / 100) *
                      plan.priceOriginal
                    ).toFixed(2)}, for ${plan.duration} ${
                      plan.duration == 1
                        ? plan.durationUnit.slice(0, -1)
                        : plan.durationUnit
                    }${
                      plan.discount > 0 ? ', save ' + plan.discount + '%' : ''
                    }`
                  "
                  :value="plan.key"
                ></v-radio>
              </v-radio-group>
            </div>
            -->
            
            <v-row>
              <v-col cols="12" sm="6">
                <v-card outlined class="mb-3">
                  <v-card-title>
                    {{ $t("view.PageMainPricing.plan_premium_name") }}
                  </v-card-title>
                  <v-card-subtitle>
                    {{ selectedPlanData.duration }} {{ selectedPlanData.durationUnit }}
                  </v-card-subtitle>
                  <v-card-text class="text-left mb-4">
                    <div v-if="originalAmount !== finalAmount" class="body-2">
                      <span class="text-decoration-line-through">RM {{ originalAmount.toFixed(2) }}</span>
                      <span class="ml-2 green--text font-weight-bold">RM {{ finalAmount.toFixed(2) }}</span>
                      <!-- <div class="caption">Coupon discount applied: {{ getCouponDiscountText() }}</div> -->
                    </div>
                    <div v-else class="body-2 font-weight-bold black--text">
                      RM {{ finalAmount.toFixed(2) }}
                    </div>
                  </v-card-text>
                </v-card>

                <div class="black--text mb-3">{{ $t("view.SlideUpgradeForm.payment_instructions") }}</div>
                <div>CIMB BANK</div>
                <div>HAMOCHI SDN BHD</div>
                <div>8010848740</div>

                <div class="text-center pt-3">
                  <v-file-input
                    v-model="receipt"
                    :label="$t('view.SlideUpgradeForm.attach_receipt_label')"
                    outlined
                    :rules="[
                      (v) =>
                        !v || v.size < 2000000 || $t('view.SlideUpgradeForm.receipt_size_validation'),
                    ]"
                  ></v-file-input>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <v-img
                  contain
                  :src="require('@/assets/qr_bank_small.png')"
                  class="mb-3"
                ></v-img>
              </v-col>
            </v-row>
          </div>
          <div v-else-if="step == 2">
            <div class="d-flex align-center justify-space-around">
              <div class="form-content text-center">
                <v-img src="/images/rainbow.png" max-height="200" contain>
                </v-img>
                <div class="text-center font-weight-bold pt-1">
                  {{ $t("view.SlideUpgradeForm.thank_you_message") }}
                </div>
                <div class="text-center pt-4">
                  <v-btn
                    width="50%"
                    rounded
                    color="success"
                    dark
                    x-large
                    @click="goHome()"
                  >
                    {{ $t("view.SlideUpgradeForm.ok_button") }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div v-if="step != 3" class="text-center pt-1">
            <v-btn
              v-if="step == 1"
              width="50%"
              rounded
              color="primary"
              dark
              x-large
              :loading="submitApi.isLoading || uploadApi.isLoading"
              @click="validate()"
            >
              {{ $t("view.SlideUpgradeForm.submit_button") }}
            </v-btn>
          </div>
          <div v-if="step != 2" class="text-center pt-2">
            <v-btn
              width="50%"
              rounded
              text
              color="primary"
              dark
              @click="back()"
            >
              {{ $t("view.SlideUpgradeForm.back_button") }}
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: {
    //
  },
  computed: {
    ...mapState({
      upgrade: (state) => state.upgrade.data,
    }),
    selectedPlanDetails() {
      if (!this.selectedPlan || !this.planPrices.PlanPricing) return null;
      return this.planPrices.PlanPricing.find(
        (plan) => plan.key === this.selectedPlan
      );
    }
  },
  props: [
    //
  ],
  watch: {
    receipt(val) {
      this.receipt = val;
      if (val) {
        this.previewUrl = URL.createObjectURL(val);
        this.uploadImage();
      } else {
        this.previewUrl = null;
      }
    },
    selectedPlan(){
      this.calculateAmount();
    }
  },
  data: () => ({
    previewUrl: null,
    receipt: null,
    appliedCoupon: null,
    originalAmount: 0,
    finalAmount: 0,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    submitApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    uploadApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    step: 1,
    planPrices: [],
    selectedPlan: "",
    selectedPlanData: {},
    planPricingKey: null,
    couponKey: null,
    receiptImageUrl: null,
    amount: 0,
  }),
  created() {
    //BOC:[api]
    this.api.method = "get";
    this.api.url = `${this.$api.servers.sso}/api/v1/en/data/plan/PLAN_PRIMARY_010`;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.planPrices = resp;
      this.planPrices.PlanPricing = this.$_.filter(
        resp.PlanPricing,
        (p) => p.priceOriginal !== "0"
      );
      this.selectedPlan =  process.env.VUE_APP_PLAN_PRICING_KEY;
      this.appliedCoupon = this.$_.cloneDeep(this.upgrade.coupon);
      if (this.appliedCoupon) {
        this.couponKey = this.appliedCoupon.key;
      }
      this.$store.commit("updateClick", { isClicked: false, coupon: this.appliedCoupon });
      this.calculateAmount();
    };
    //EOC

    this.submitApi.url = `${this.$api.servers.sso}/api/v1/en/backend/account/plan/subscribe`;
    this.submitApi.callbackReset = () => {
      this.submitApi.isLoading = true;
      this.submitApi.isError = false;
    };
    this.submitApi.callbackError = (e) => {
      this.submitApi.isLoading = false;
      this.submitApi.isError = true;
      this.submitApi.error = e;
    };
    this.submitApi.callbackSuccess = () => {
      this.submitApi.isLoading = false;
      this.step++;
    };
    //EOC

    this.uploadApi.url = `${this.$api.servers.sso}/api/v1/en/account/upgrade/uploadReceipt`;
    this.uploadApi.callbackReset = () => {
      this.uploadApi.isLoading = true;
      this.uploadApi.isError = false;
    };
    this.uploadApi.callbackError = (e) => {
      this.uploadApi.isLoading = false;
      this.uploadApi.isError = true;
      this.uploadApi.error = e;
    };
    this.uploadApi.callbackSuccess = (resp) => {
      this.uploadApi.isLoading = false;
      console.log(resp);
    };
    //EOC
  },
  mounted() {
    this.$api.fetch(this.api);
  },
  methods: {
    calculateAmount() {
      if (!this.selectedPlan || !this.planPrices.PlanPricing) return;
      
      this.selectedPlanData = this.planPrices.PlanPricing.find(
        (plan) => plan.key === this.selectedPlan
      );

      const selectedPlanData = this.selectedPlanData;

      if (!selectedPlanData) return;

      this.originalAmount = ((100 - selectedPlanData.discount) / 100) * selectedPlanData.priceOriginal;

      if (this.appliedCoupon) {
        if (this.appliedCoupon.discountType === 'percentage') {
          const couponDiscount = parseFloat(this.appliedCoupon.discountValue);
          this.finalAmount = this.originalAmount * (1 - couponDiscount / 100);
        } else if (this.appliedCoupon.discountType === 'fixed_amount') {
          const couponDiscount = parseFloat(this.appliedCoupon.discountValue);
          this.finalAmount = Math.max(0, this.originalAmount - couponDiscount);
        } else {
          this.finalAmount = this.originalAmount;
        }
      } else {
        this.finalAmount = this.originalAmount;
      }

      this.amount = this.finalAmount;
    },
    getCouponDiscountText() {
      if (!this.appliedCoupon) return '';
      
      if (this.appliedCoupon.discountType === 'percentage') {
        return `${this.appliedCoupon.discountValue}% off`;
      } else if (this.appliedCoupon.discountType === 'fixed_amount') {
        return `RM ${parseFloat(this.appliedCoupon.discountValue).toFixed(2)} off`;
      }
      return '';
    },
    next() {
      this.step++;
      this.submitApi.isLoading = false;
    },
    back() {
     this.$router.go(-1)
    },
    uploadImage() {
      this.uploadApi.isLoading = true;
      const formData = new FormData();
      formData.append("receipt", this.receipt);
      axios
        .post(
          this.$api.servers.sso + "/api/v1/en/account/upgrade/uploadReceipt",
          formData,
          {},
          {}
        )
        .then((response) => {
          this.uploadApi.isLoading = false;
          this.receiptImageUrl = response.data.receiptImageUrl;
        });
    },
    validate() {
      this.submitApi.callbackReset();
      if (this.$refs.formName.validate()) {
        if (!this.receiptImageUrl) {
          this.submitApi.callbackError(this.$t("view.SlideUpgradeForm.error_no_receipt"));
        } else {
          this.submit();
        }
      } else {
        this.submitApi.callbackError(this.$t("view.SlideUpgradeForm.error_form_validation"));
      }
    },
    submit() {
      this.submitApi.params = this.$_.clone({
        amount: this.finalAmount.toFixed(2),
        planPricingKey: this.selectedPlan,
        couponKey: this.couponKey,
        currencyType: "MYR",
        receiptImageUrl: this.receiptImageUrl,
      });
      this.$api.fetch(this.submitApi);
    },
     goHome() {
      this.$router.push({ name: "PageMainHome" });
    },
  },
};
</script>

<style scoped>
.form-content {
  width: 300px !important;
}
.v-stepper__header {
  box-shadow: none !important;
}
div .v-text-field__prefix {
  color: black !important;
}
</style>